export default function handleBlkSubmitValues(values, fields) {
  const handleConfigurationObj = () => {
    const configuration = {
      allow_custom_config: false,
      behavior: {
        data_propagation: values.data_propogation || false,
      },
      rules: {
        programs: [],
      },
      system_required: values.block_required,
    }
    return JSON.stringify(configuration)
  }
  const handleFieldsValues = () => {
    return JSON.stringify(fields)
  }

  const newBlock = {
    block_name: values.block_name,
    block_title: values.block_title,
    configuration: handleConfigurationObj(),
    fields: handleFieldsValues(),
  }

  return {
    ...newBlock,
  }
}
